import produce from 'immer'
// import reject from 'lodash/reject'
// import isNull from 'lodash/isNull'

import {
  FETCH_COMPETITIONS_REQUESTED,
  FETCH_COMPETITIONS_SUCCEEDED,
  FETCH_COMPETITIONS_FAILED,
} from './actionTypes'

export const defaultSortFilterComments = {
  SarafanAccessToken: null,
}

const initialState = defaultSortFilterComments
/* eslint no-param-reassign: "error" */
const commentsReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_COMPETITIONS_REQUESTED:
      draft.loading = true
      return draft

    case FETCH_COMPETITIONS_SUCCEEDED:
      draft.competitions = action.payload.competitions
      draft.loading = false
      return draft

    case FETCH_COMPETITIONS_FAILED:
      draft.error = action.payload.error
      draft.loading = true
      return draft

    default:
      return draft
  }
})

export default commentsReducer



// WEBPACK FOOTER //
// ./src/store/token/reducer.js